<template>
  <div v-bind:class="{ printVersion: printVersion }">
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <portfolio-header :general-data="portfolioAnalysis" :is-asset-class-section="true" :menu-data="menuData" :current-asset-class="'fondosrf'" :section-label="'Fondos RF'" :asset-class-amount="assetClassAmount" :asset-class-percentage="assetClassPercentage">
        </portfolio-header>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <asset-allocation v-bind:printableVersion="printableVersion" :donnut-data="assetAllocation.data" :info-data="assetAllocation.titles" :uni-color="assetClassColor" :donnut-labels="assetAllocation.labels" :colors="assetAllocation.dataColors">
        </asset-allocation>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="20" class="sectionContainer">
        <span class="section-title">Fondos Renta Fija</span>
        <div class="subtitle-line" v-if="printVersion"></div>
        <asset-overview-table v-bind:graph_data="investments" v-bind:percentage_color="assetClassColor.color" :current-asset-class="'fondosrf'" :is-clickable="true">
        </asset-overview-table>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="20" class="sectionContainer">
        <span class="section-title">Rendimiento anualizado por fondo</span>
        <div class="subtitle-line" v-if="printVersion"></div>
        <asset-overview-table v-bind:graph_data="yieldByAsset">
        </asset-overview-table>
      </el-col>
    </el-row>
    <div class="avoid-page-break">
      <el-row v-if="printVersion">
        <el-col :span="24" class="sectionContainer">
          <span class="section-title" v-if="printVersion">
              Rendimiento Ponderado y Comisiones en RF
            </span>
          <div class="subtitle-line" v-if="printVersion"></div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col v-if="!printVersion" :span="8" class="sectionContainer">
          <span class="section-title">Rendimiento Ponderado y Comisiones en RF</span>
        </el-col>
        <el-col :span="12" class="sectionContainer">
          <horizontal-bar-chart v-bind:graph_data="yieldAndCommissions" :asset-class-color="assetClassColor.color">
          </horizontal-bar-chart>
        </el-col>
      </el-row>
    </div>
    <div class="avoid-page-break">
      <el-row type="flex" justify="center">
        <el-col :span="20" class="sectionContainer">
          <span class="section-title">Comparativo Benchmark del mercado</span>
          <div class="subtitle-line" v-if="printVersion"></div>
          <bar-chart v-bind:graph_data="assetClassBenchmark" :asset-class-color="assetClassColor.color">
          </bar-chart>
        </el-col>
      </el-row>
    </div>
    <div class="avoid-page-break">
      <el-row type="flex" justify="center">
        <el-col :span="20" class="sectionContainer">
          <span class="section-title">Calificación</span>
          <div class="subtitle-line" v-if="printVersion"></div>
          <special-slider v-bind:graph_data="scoreDistribution"></special-slider>
        </el-col>
      </el-row>
    </div>
    <!-- Footer section -->
    <div class="avoid-page-break">
      <el-row type="flex" justify="center">
        <el-col :span="20" class="sectionContainer">
          <div v-if="assetClassComments.length > 0 && printVersion">
            <span class="section-title">Comentarios de mercado Fondos RF</span>
            <div class="subtitle-line" v-if="printVersion"></div>
          </div>
          <comments :is-asset-class-view="true" :comments="assetClassComments" :asset-class-id="assetClassId" :is-print-version="printVersion"></comments>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" v-if="!printVersion">
        <el-col :span="20">
          <portfolio-footer :creation-date="portfolioAnalysis.updatedDataAt">
          </portfolio-footer>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import PortfolioHeader from "./PortfolioHeader";
  import AssetAllocation from "./DonnutChartSection";
  import barChartComponent from "./BarChart";
  import AssetOverviewTable from "./TableData";
  import CommentsSection from "./CommentsSection";
  import horizontalBarChart from "./VerticalTableData2";
  import specialSlider from "./SpecialSlider";
  import PortfolioFooter from "./PortfolioFooter";
  import {
    legalNoticeText
  } from "@/componentConfig";
  import {
    getPortfolioAnalysis
  } from "@/graphql";
  export default {
    name: "AssetClassFondosRF",
    components: {
      "portfolio-header": PortfolioHeader,
      "asset-allocation": AssetAllocation,
      "asset-overview-table": AssetOverviewTable,
      comments: CommentsSection,
      "bar-chart": barChartComponent,
      "horizontal-bar-chart": horizontalBarChart,
      "portfolio-footer": PortfolioFooter,
      "special-slider": specialSlider
    },
    props: {
      printableVersion: false
    },
    mounted() {
      this.getPortfolioData(this.$route.params.id);
      if (this.printableVersion == true) {
        this.printVersion = true;
      }
    },
    data() {
      return {
        printVersion: false,
        legalNotice: legalNoticeText,
        showModal: false,
        assetClassColor: {
          name: "Fondos RF",
          color: "#C2BFE0"
        },
        assetAllocation: {},
        menuData: {},
        assetClassComments: [],
        assetClassId: 0
      };
    },
    computed: {
      portfolioAnalysis: function() {
        return this.$store.getters.currentPortfolioAnalysis;
      },
      assetClassAmount: function() {
        return this.$store.getters.fondosrf.amount;
      },
      assetClassPercentage: function() {
        return this.$store.getters.fondosrf.percentage;
      },
      investments: function() {
        return {
          titles: [{
            prop: "assetName",
            label: "Emisora"
          }],
          titles2: [{
              prop: "amount",
              label: "Monto"
            },
            // {
            //   prop: "accumulatedYield",
            //   label: `Rto Acum ${this.labels.accum}`
            // },
            {
              prop: "commission",
              label: "Comisión"
            }
          ],
          data: this.$store.getters.fondosrf.investments,
          percentage: true,
          extraDataThree: true
        };
      },
      yieldByAsset: function() {
        return {
          titles: [{
              prop: "assetName",
              label: "Emisora"
            },
            {
              prop: "year3",
              label: `${this.labels.year3}`
            },
            {
              prop: "year2",
              label: `${this.labels.year2}`
            },
            {
              prop: "year1",
              label: `${this.labels.year1}`
            },
            {
              prop: "accumulatedYield",
              label: `Acum. ${this.labels.lastYear}`
            }
          ],
          data: this.$store.getters.fondosrf.investmentsYield
        };
      },
      yieldAndCommissions: function() {
        return [{
            name: `Rendimientos acum. ${this.labels.lastYear}`,
            value: this.$store.getters.fondosrf.accumulatedYields
          },
          {
            name: "Comisiones",
            value: this.$store.getters.fondosrf.comissions
          }
        ];
      },
      assetClassBenchmark: function() {
        return {
          title: "Comparativo benchmark del mercado",
          dates: [`Rto.${this.labels.year3}`, `Rto.${this.labels.year2}`, `Rto.${this.labels.year1}`, `Rto.Acum.${this.labels.lastYear}`],
          trace1: {
            name: "Fondos RF",
            data: this.$store.getters.fondosrf.benchmarkComparative.assetsData
          },
          trace2: {
            name: "Cetes 28 días",
            data: this.$store.getters.fondosrf.benchmarkComparative.benchmarkData
          }
        };
      },
      scoreDistribution: function() {
        return {
          items: this.$store.getters.fondosrf.scoreDistribution
        };
      },
      labels: function() {
        return this.$store.getters.currentPortfolioAnalysis.labels
      }
    },
    watch: {
      portfolioAnalysis: function(value) {
        if (value) {
          this.getChartData(value);
          this.assetClassComments = value.fondosRF.comments;
          this.assetClassId = value.fondosRF.assetClassId;
        }
      }
    },
    methods: {
      getPortfolioData(id) {
        this.$apollo
          .query({
            query: getPortfolioAnalysis,
            variables: {
              id
            },
            fetchPolicy: "cache-first"
          })
          .then(data => this.analysisSuccessHandler(data.data.portfolioAnalysis))
          .catch(error => {
            this.$message({
              type: "error",
              message: "Ocurrió un error intenta más tarde"
            });
          });
      },
      closeModal() {
        this.showModal = false;
      },
      analysisSuccessHandler(analaysisData) {
        this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
      },
      getChartData(portfolioAnalysis) {
        const objectKeys = [
          "fondosRF",
          "fondosRV",
          "deuda",
          "capitales",
          "estructurados"
        ];
        const placeholders = [
          "Fondos RF",
          "Fondos RV",
          "Deuda",
          "Capitales",
          "Estructurados"
        ];
        const colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
        let data = [];
        let labels = [];
        let titles = [];
        let menuData = [];
        let dataColors = [];
        for (const index in objectKeys) {
          const id = objectKeys[index];
          const label = placeholders[index];
          const color = colors[index];
          if (portfolioAnalysis[id].amount !== 0) {
            data.push(portfolioAnalysis[id].percentage);
            labels.push(label);
            const titleObject = {
              name: label,
              percentage: portfolioAnalysis[id].percentage,
              amount: portfolioAnalysis[id].amount,
              id: id.toLowerCase()
            };
            titles.push(titleObject);
            if (label !== this.assetClassColor.name) {
              menuData.push(titleObject);
              dataColors.push("#A5A5A5");
            } else {
              dataColors.push(color);
            }
          }
        }
        this.assetAllocation = {
          data,
          labels,
          titles,
          dataColors
        };
        this.menuData = menuData;
      }
    }
  };
</script>

<style scoped>
  .subtitle-line {
    border-bottom: 1px solid #e9e9e9;
    margin-top: 8px;
  }
  .sectionContainer {
    padding-top: 25px;
  }
  .section-title {
    font-size: 18px;
    font-weight: 500;
  }
  .portfolioComment-toggle {
    color: #4a4a4a;
    font-size: 14px;
    font-weight: bold;
  }
  /* For the subtitles */
  .printVersion .sectionContainer {
    padding-top: 0px !important;
  }
  .printVersion .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #C2BFE0;
  }
</style>



// WEBPACK FOOTER //
// src/components/AssetClassFondosRF.vue